import React from "react";
import { Autocomplete } from "@mui/material";
import { TextField, Checkbox, FormControlLabel } from "@mui/material";

import { ContextualHelp } from "../../../../components/ui";
import { IAllowedFeature } from "../../constants";
import { TAllowedFeaturesList } from "../../../../constants";
import { useAdminProviderDataContext } from "../../../../context";

interface IProps {
  label: string;
  options: Record<IAllowedFeature["name"], IAllowedFeature>;
  allowed_features: TAllowedFeaturesList;
  setFieldValue: (fieldName: string, value: boolean) => void;
}
const AllowedFeaturesAutocomplete: React.FC<IProps> = ({
  options,
  allowed_features,
  setFieldValue,
  label,
}) => {
  const { user } = useAdminProviderDataContext();

  return (
    <div>
      <Autocomplete
        disableCloseOnSelect
        fullWidth
        renderInput={(params) => <TextField {...params} label={label} />}
        options={Object.keys(options)}
        getOptionLabel={(option) => options[option].label}
        groupBy={(option) => options[option]?.group || ""}
        renderOption={(fieldName, option) => {
          const {
            name,
            label,
            contextualHelpText = "",
            isSubOption,
            subOptionsList,
            group,
          } = options[option];
          const [, optionName] = name.split(".");

          const isDisabledSubOption = () => {
            if (!user.allowed_features.change_agent_allowed_features) {
              return true;
            }
            if (isSubOption) {
              const parentOption = Object.keys(options).find((key) => {
                if (
                  options[key as string].subOptionsList &&
                  options[key as string].group === group
                ) {
                  return true;
                }
                return false;
              });
              return !allowed_features[parentOption as string];
            }
          };

          return (
            <ContextualHelp title={contextualHelpText}>
              <FormControlLabel
                sx={{
                  cursor: "default",
                  pointerEvents: "none",
                  ...(isSubOption && { marginLeft: "15px" }),
                }}
                label={label}
                control={
                  <Checkbox
                    disabled={isDisabledSubOption()}
                    sx={{
                      pointerEvents: "all",
                      marginLeft: "18px",
                    }}
                    name={label}
                    checked={!!allowed_features[optionName as string]}
                    onChange={(e) => {
                      setFieldValue(`allowed_features.${optionName}`, e.target.checked);
                      if (subOptionsList && !e.target.checked) {
                        subOptionsList.forEach((subOption) => {
                          setFieldValue(`allowed_features.${subOption}`, false);
                        });
                      }
                    }}
                  />
                }
              />
            </ContextualHelp>
          );
        }}
      />
    </div>
  );
};

export default AllowedFeaturesAutocomplete;
